import { db, auth, storage, COLLECTIONS, SUBCOLLECTIONS } from "../../firebase/firebase";
import {
  doc,
  setDoc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  collection,
  getDocs,
  QueryDocumentSnapshot,
  query,
  where,
  limit,
  startAfter,
  QueryConstraint,
  or,
  and,
  QueryCompositeFilterConstraint,
  QueryNonFilterConstraint,
  Timestamp,
  WhereFilterOp,
  orderBy,
  endBefore,
  limitToLast,
  getCountFromServer,
  QueryFieldFilterConstraint,
  getAggregateFromServer ,
  count,  
  
} from "firebase/firestore";


import { SKArtifactPayload, SKArtifact, Tier, ContentSubstate, ContentState, CreatorArtifactType, ModArtifactType, getContentHistoryStatusString, SKContentReport } from "../../models/SKArtifact";
import { CustomError, isError } from "../../utils/customeError";
import { string } from "yup";
import { SKContentStatusHistory } from "../../models/SKArtifact";
import { Pagination } from "../enums";
import { ChannelState } from "../../models/SKChannel";



interface FetchArtifactListResult {
  docs: SKArtifact[];
  firstDoc: QueryDocumentSnapshot | undefined;
  lastDoc: QueryDocumentSnapshot | undefined;
  hasNext: boolean;
  hasPrev: boolean
}

interface ArtifactReports {
  docs: SKContentReport[];
  firstDoc: QueryDocumentSnapshot | undefined;
  lastDoc: QueryDocumentSnapshot | undefined;
  hasNext: boolean;
  hasPrev: boolean
}

const getCountsCreatorContent = async (channelId:string): Promise<{ [CreatorArtifactType.Draft]:number,[CreatorArtifactType.Active]:number, [CreatorArtifactType.Review]:number, [CreatorArtifactType.Withdrawn]:number,[CreatorArtifactType.Rejected]:number }> => {
  const feeedRef = collection(db, COLLECTIONS.FEEDS);

  const draftQuery = query(feeedRef, where("status", "==", ContentState.DRAFT),where("subStatus", "==", ContentSubstate.NONE),  where("channelId", "==", channelId));
  const activeQuery = query(feeedRef, where("status", "==", ContentState.ACTIVE),  where("channelId", "==", channelId));
  const inreviewQuery = query(feeedRef, where("status", "==", ContentState.IN_REVIEW),  where("channelId", "==", channelId));
  const withdrawnQuery = query(feeedRef, where("status", "==", ContentState.DRAFT),where("subStatus", "==", ContentSubstate.WITHDRAWN),  where("channelId", "==", channelId));
  const rejectedQuery = query(feeedRef, where("status", "==", ContentState.DRAFT),where("subStatus", "==", ContentSubstate.REJECTED),  where("channelId", "==", channelId));


  try {
    // Execute all queries in parallel
    //getCountFromServer(draftQuery)
    const [ draftSnap,activeSnap,inreviewSnap, withdrawnSnap, rejectedSnap ] = await Promise.all([
      getAggregateFromServer(draftQuery, { count: count() }),
      getAggregateFromServer(activeQuery, { count: count() }),
      getAggregateFromServer(inreviewQuery, { count: count() }),
      getAggregateFromServer(withdrawnQuery, { count: count() }),
      getAggregateFromServer(rejectedQuery, { count: count() })
    ]);


    return {
      [CreatorArtifactType.Draft]: draftSnap.data().count,
      [CreatorArtifactType.Active]: activeSnap.data().count,
      [CreatorArtifactType.Review]: inreviewSnap.data().count,
      [CreatorArtifactType.Withdrawn]: withdrawnSnap.data().count,
      [CreatorArtifactType.Rejected]: rejectedSnap.data().count,
    };
  } catch (error) {
    console.error("Error getting channel counts: ", error);
    return {   [CreatorArtifactType.Draft]: 0,
      [CreatorArtifactType.Active]:0,
      [CreatorArtifactType.Review]: 0,
      [CreatorArtifactType.Withdrawn]:0,
      [CreatorArtifactType.Rejected]: 0,
    }; // Return 0 for all if there's an error
  }
}



const getCountsModeratorContent = async (): Promise<{ [ModArtifactType.Review]:number,[ModArtifactType.EditReview]:number, [ModArtifactType.Active]:number, [ModArtifactType.Withdrawn]:number, [ModArtifactType.Rejected]:number, [ModArtifactType.Flagged]:number }> => {
  const feedRef = collection(db, COLLECTIONS.FEEDS);
  const reportsRef = collection(db, `${COLLECTIONS.REPORTS}/content/reports`);

  
  
  const inreviewQuery = query(feedRef, where("status", "==", ContentState.IN_REVIEW),where("channelStatus", "==", ChannelState.ACTIVE) );
  const editReviewQuery = query(feedRef, where("status", "==", ContentState.ACTIVE),where("subStatus", "==", ContentSubstate.EDIT_IN_REVIEW), where("channelStatus", "==", ChannelState.ACTIVE));
  const activeQuery = query(feedRef, where("status", "==", ContentState.ACTIVE),where("channelStatus", "==", ChannelState.ACTIVE));
  const withdrawnQuery = query(feedRef, where("status", "==", ContentState.DRAFT),where("subStatus", "==", ContentSubstate.WITHDRAWN),where("channelStatus", "==", ChannelState.ACTIVE));
  const rejectedQuery = query(feedRef, where("status", "==", ContentState.DRAFT),where("subStatus", "==", ContentSubstate.REJECTED),where("channelStatus", "==", ChannelState.ACTIVE));
  const flaggedQuery =  query(reportsRef, where("reportCount",">", 0));
  
  try {
    // Execute all queries in parallel
    const [inreviewSnap,editReview,activeSnap,withdrawnSnap,rejectedSnap, flaggedSnap] = await Promise.all([
      getCountFromServer(inreviewQuery),
      getCountFromServer(editReviewQuery),
      getCountFromServer(activeQuery),
      getCountFromServer(withdrawnQuery),
      getCountFromServer(rejectedQuery),
      getCountFromServer(flaggedQuery)
    ]);

    return {
      [ModArtifactType.Review]: inreviewSnap.data().count,
      [ModArtifactType.EditReview]: editReview.data().count,
      [ModArtifactType.Active]: activeSnap.data().count,
      [ModArtifactType.Withdrawn]: withdrawnSnap.data().count,
      [ModArtifactType.Rejected]: rejectedSnap.data().count,
      [ModArtifactType.Flagged]: flaggedSnap.data().count
    };
  } catch (error) {
    console.error("Error getting channel counts: ", error);
    return {  [ModArtifactType.Review]: 0,
      [ModArtifactType.EditReview]: 0,
      [ModArtifactType.Active]: 0,
      [ModArtifactType.Withdrawn]: 0,
      [ModArtifactType.Rejected]: 0,
      [ModArtifactType.Flagged]: 0
    }; // Return 0 for all if there's an error
  }
}

// Firestore services
const createArtifact = async (data: SKArtifactPayload) : Promise<string> => {
  try {
    let artifactData = {...data, createdDate: Timestamp.now(), lastActivityDate:Timestamp.now(), updatedDate: Timestamp.now(), userId: auth.currentUser?.uid}
    let ref = await addDoc(collection(db, COLLECTIONS.FEEDS), artifactData);
     await updateStatusHistory(ref.id, "created")
    return ref.id
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
  
};

const createArtifactEdit = async (contentId: string, data: SKArtifactPayload) : Promise<SKArtifactPayload> => {
  try {
    let artifactData = {...data, createdDate: Timestamp.now(), updatedDate: Timestamp.now(), userId: auth.currentUser?.uid}
    let ref = await doc(db, COLLECTIONS.CONTENT_CHANGE_REQUESTS, contentId);
    // const docRef = doc(db, "storeChannelsEdits", contentId);
    await setDoc(ref, artifactData);
    // await updateStatusHistory(ref.id, "Content Edit Created")
    await updateArtifactStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_IN_DRAFT)
    return {...artifactData, status:ContentState.ACTIVE, subStatus:ContentSubstate.EDIT_IN_DRAFT};
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
  
};



const updateStatusHistory = async ( artifactId:string, status:string, reason?:string, note?:string ) : Promise<void> => {
  try {
    if(reason){
      if(note){
        await addDoc(collection(db, COLLECTIONS.FEEDS, artifactId, SUBCOLLECTIONS.CONTENT_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason, note} );
      }else{
        await addDoc(collection(db, COLLECTIONS.FEEDS, artifactId, SUBCOLLECTIONS.CONTENT_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason} );
      }
    }else{
      await addDoc(collection(db, COLLECTIONS.FEEDS, artifactId, SUBCOLLECTIONS.CONTENT_STATUS_LOGS ), {status, createdDate: Timestamp.now()} );
    }
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while updating Artefact Status');
  }
};



const getStatusHistory = async ( artifactId:string) : Promise<SKContentStatusHistory[]> => {
  let ref = collection(db, COLLECTIONS.FEEDS, artifactId, SUBCOLLECTIONS.CONTENT_STATUS_LOGS)
  try {
    // Retrieve the documents from the "History" subcollection
    const querySnapshot = await getDocs(query(ref,orderBy("createdDate", "desc")));
    
    // Map over the documents and extract their data
    const historyData = querySnapshot.docs.map(doc => ({
      ...doc.data() // Document data
    })) as SKContentStatusHistory[]

    return historyData;
  } catch (error) {
    console.error("Error getting History collection: ", error);
    throw error; // Handle the error appropriately
  }

  
}

const getArtifact = async (artifactId: string) : Promise<SKArtifact> => {
  const atrifectRef = doc(db, COLLECTIONS.FEEDS, artifactId)
  const docSnap = await getDoc(atrifectRef);

  if (docSnap.exists()) {
    try {
      const subcollectionRef = collection(atrifectRef, SUBCOLLECTIONS.CONTENT_STATUS_LOGS);
      const snapshot = await getDocs(subcollectionRef);
      if (snapshot.empty) {
        console.log('Subcollection is empty or does not exist.');
        return {...docSnap.data(), hasHistory:false } as SKArtifact;
      
      } else {
        console.log('Subcollection exists and has documents.');
        return {...docSnap.data(), hasHistory:true } as SKArtifact;
      
      }
    } catch (error) {
      console.error('Error checking for subcollection:', error);
      return {...docSnap.data(), hasHistory:false} as SKArtifact;
    }

    
  } else {
    throw new Error("Artifact does not exist!");
  }
};

const getArtifactEdit = async (artifactId: string) : Promise<SKArtifact> => {
  const atrifectRef = doc(db, COLLECTIONS.CONTENT_CHANGE_REQUESTS, artifactId)
  const docSnap = await getDoc(atrifectRef);

  if (docSnap.exists()) {
    try {
      const subcollectionRef = collection(atrifectRef, SUBCOLLECTIONS.CONTENT_STATUS_LOGS);
      const snapshot = await getDocs(subcollectionRef);
      if (snapshot.empty) {
        console.log('Subcollection is empty or does not exist.');
        return {...docSnap.data(), hasHistory:false } as SKArtifact;
      
      } else {
        console.log('Subcollection exists and has documents.');
        return {...docSnap.data(), hasHistory:true } as SKArtifact;
      
      }
    } catch (error) {
      console.error('Error checking for subcollection:', error);
      return {...docSnap.data(), hasHistory:false} as SKArtifact;
    }

    
  } else {
    throw new Error("Artifact does not exist!");
  }
};


const applyPaginationQuery = (pageSize: number, moveTo?:Pagination, currentDoc?:QueryDocumentSnapshot): QueryNonFilterConstraint[] =>{

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  switch (moveTo) {
    case Pagination.Next:
      if (currentDoc) {
        myNonFilterQuery.push(startAfter(currentDoc))
        myNonFilterQuery.push(limit(pageSize));
      }
      break;

    case Pagination.Previous:
      if (currentDoc) {
        myNonFilterQuery.push(endBefore(currentDoc))
        myNonFilterQuery.push(limitToLast(pageSize));
      }
      break;

    case Pagination.First:
      myNonFilterQuery.push(limit(pageSize));
      break;

    case Pagination.Last:
      myNonFilterQuery.push(limitToLast(pageSize));
      break;

    default:
      myNonFilterQuery.push(limit(pageSize));
      
  }

  return myNonFilterQuery;

}

const fetchMyArtifacts = async (filterFields: string[], channelId:string, operator:string, filterValues: unknown[],  pageSize: number, moveTo?:Pagination, currentDoc?:QueryDocumentSnapshot, isFlagged?:boolean, sortConfig?:{key:string; direction: "asc" | "desc"}): Promise<FetchArtifactListResult>=> {

  let ref = collection(db, COLLECTIONS.FEEDS)
  let myNonFilterQuery = applyPaginationQuery(moveTo === Pagination.Last ? pageSize: pageSize + 1 ,moveTo, currentDoc);
  let constratints = [ where("channelId", "==", channelId)]

   
  if (filterFields.length > 0 && filterValues.length > 0) {
    for (let i = 0; i < filterFields.length; i++) {
      const fieldPath = filterFields[i] as string;
      const fieldValue = filterValues[i] as string;
      if(fieldPath && fieldValue) constratints.push(where(fieldPath, '==', fieldValue));
    }
  }
 
  let compositeQuery: QueryCompositeFilterConstraint =  and(...constratints)

  let sortArray = [orderBy("createdDate", "desc")]
  if(sortConfig){
    sortArray= [orderBy(sortConfig.key, sortConfig.direction)]
  }
  const q  = query(ref,compositeQuery , ...sortArray , ...myNonFilterQuery);
  try {
    const querySnapshot = await getDocs(q);
    // const docs = querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   ...doc.data()
    // })) as SKArtifact[];

    const docs = querySnapshot.docs.slice(0, pageSize).map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as SKArtifact[];

    let firstDoc = querySnapshot.size > 0 ? querySnapshot.docs[0] : undefined;
    // setLastVisible(docs.length > pageSize ? docs[pageSize - 1] : null);
    let lastDoc = querySnapshot.size > pageSize ? querySnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? querySnapshot.docs[pageSize - 1]: undefined);
    let hasNext = moveTo === Pagination.Next ? querySnapshot.size > pageSize :  moveTo === Pagination.First && querySnapshot.size <= pageSize ? false : true;
    
    let hasPrev = !!currentDoc;
    switch (moveTo) {
      case Pagination.First:
        hasPrev = false
        break;
      case Pagination.Last:
        hasNext = false
        break;
      default:
        break;
    }
    return {docs, firstDoc, lastDoc , hasNext, hasPrev};
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const fetchReportedContent = async (
  filterFields: string[],
  filterValues: unknown[],
  pageSize: number,
  moveTo?: Pagination,
  currentDoc?: QueryDocumentSnapshot,
  sortConfig?:{key:string; direction: "asc" | "desc"}
): Promise<FetchArtifactListResult> => {
  try {
    const reportsRef = collection(db, `${COLLECTIONS.REPORTS}/content/reports`);

    // Step 1: Fetch top reported content IDs (sorted by `reportCount`)

    // const channelReportDoc = db.collection(COLLECTIONS.REPORTS).doc("channel");
    // const reportRef = channelReportDoc.collection(COLLECTIONS.REPORTS).doc(channelID);
    // const contentRef = db.collection("storeChannels").doc(channelID);
    // const userActionRef = reportRef.collection("reportedUsers").doc(userID);

    let reportsQuery = query(reportsRef, orderBy("lastReportedDate", "desc"), where("reportCount",">", 0), limit(pageSize + 1));
    
    const reportsSnapshot = await getDocs(reportsQuery);
    const reportedIDs = reportsSnapshot.docs.map(doc => doc.id);
   const reportCountsMap = new Map(reportsSnapshot.docs.map(doc => {const {reportCount,lastReportedDate} = doc.data(); return [doc.id, {reportCount , lastReportedDate}]}));

    if (reportedIDs.length === 0) {
      return { docs: [], firstDoc: undefined, lastDoc: undefined, hasNext: false, hasPrev: false };
    }

    // Step 2: Prepare filters and sorting for `Feeds`
    let ref = collection(db, COLLECTIONS.FEEDS);
    let constraints: QueryFieldFilterConstraint[] = [];

    if (filterFields.length > 0 && filterValues.length > 0) {
      for (let i = 0; i < filterFields.length; i++) {
        const fieldPath = filterFields[i];
        const fieldValue = filterValues[i];
        if (fieldPath && fieldValue) constraints.push(where(fieldPath, "==", fieldValue));
      }
    }

    
    let sortArray = [orderBy("createdDate", "desc")];

    if (sortConfig) {
      sortArray = [orderBy(sortConfig.key, sortConfig.direction)];
    }

    // Firestore's `where("in")` query is limited to 30 elements, so handle batching
    const batchQueries = [];

    for (let i = 0; i < reportedIDs.length; i += 10) {
      const batchIDs = reportedIDs.slice(i, i + 10);
      let newConstraint = [...constraints]
      newConstraint.push(where("__name__", "in", batchIDs))
      let compositeQuery: QueryCompositeFilterConstraint = and(...newConstraint);
      batchQueries.push(getDocs(query(ref,compositeQuery, ...sortArray)));
    }

    const batchResults = await Promise.all(batchQueries);
    const contentDocs = batchResults.flatMap(result => result.docs);

    // Step 3: Reorder results to match original `reportCount` order
    const docs = reportedIDs.map(contentID => {
      const doc = contentDocs.find(d => d.id === contentID);
      return doc ? {
        id: doc.id,
        ...doc.data(),
        reportCount: reportCountsMap.get(contentID)?.reportCount || 0,
        lastReportedDate: reportCountsMap.get(contentID)?.lastReportedDate || 0
      } : null;
    }).filter(item => item !== null) as SKArtifact[];

    let firstDoc = docs.length > 0 ? reportsSnapshot.docs[0] : undefined;
    let lastDoc = docs.length > pageSize ? reportsSnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? reportsSnapshot.docs[pageSize - 1] : undefined);
    
    let hasNext = moveTo === Pagination.Next ? reportsSnapshot.size > pageSize : moveTo === Pagination.First && reportsSnapshot.size <= pageSize ? false : true;
    let hasPrev = !!currentDoc;

    switch (moveTo) {
      case Pagination.First:
        hasPrev = false;
        break;
      case Pagination.Last:
        hasNext = false;
        break;
      default:
        break;
    }

    return { docs, firstDoc, lastDoc, hasNext, hasPrev };
  } catch (error) {
    console.error("Error fetching reported content:", error);
    throw new Error("An error occurred while fetching data");
  }
};

 const fetchArtifacts = async (filterFields: string[], operator:string, filterValues: unknown[],  pageSize: number, currentDoc?:QueryDocumentSnapshot, isFlagged?:boolean, moveTo?:Pagination, sortConfig?:{key:string; direction: "asc" | "desc"} ): Promise<FetchArtifactListResult> => {

  let ref = collection(db, COLLECTIONS.FEEDS)
  
  // let myQuery: QueryConstraint[] = []
  // myQuery.push(where(filterField, operator as WhereFilterOp, filterValue))
  let myNonFilterQuery = applyPaginationQuery(moveTo === Pagination.Last ? pageSize: pageSize + 1, moveTo, currentDoc);
 let constratints:QueryFieldFilterConstraint[]  = []
   
  if (filterFields.length > 0 && filterValues.length > 0) {
    for (let i = 0; i < filterFields.length; i++) {
      const fieldPath = filterFields[i] as string;
      const fieldValue = filterValues[i] as string;
      if(fieldPath && fieldValue) constratints.push(where(fieldPath, '==', fieldValue));
    }
  }
 
 

  //let constraints = [where(filterField, operator as WhereFilterOp, filterValue)]

  // if(isFlagged){
  //   constraints.push(where("flagged", "==", true))
  // }

  let compositeQuery: QueryCompositeFilterConstraint =  and(...constratints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  // if (lastDocument) {
  //   myNonFilterQuery.push(startAfter(lastDocument))
  // }
  // const q  = query(ref, ...myQuery);
  let sortArray = [orderBy("createdDate", "desc")]

  if(sortConfig){
    sortArray= [orderBy(sortConfig.key, sortConfig.direction)]
  }
  const q  = query(ref, compositeQuery, ...sortArray , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   let d = doc.data() as SKArtifact
    //   //let document = {id: d.id, }
      
    //   return doc.data() as SKArtifact
    // });

    // const docs = querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   ...doc.data()
    // })) as SKArtifact[];

    const docs = querySnapshot.docs.slice(0, pageSize).map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as SKArtifact[];

    // const firstDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[0] : undefined;
    // const lastDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : undefined;
    // const hasNext = querySnapshot.size === pageSize;

    let firstDoc = querySnapshot.size > 0 ? querySnapshot.docs[0] : undefined;
    // setLastVisible(docs.length > pageSize ? docs[pageSize - 1] : null);
    let lastDoc = querySnapshot.size > pageSize ? querySnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? querySnapshot.docs[pageSize - 1]: undefined);
    let hasNext = moveTo === Pagination.Next ? querySnapshot.size > pageSize :  moveTo === Pagination.First && querySnapshot.size <= pageSize ? false : true;
    

    let hasPrev = !!currentDoc;
    switch (moveTo) {
      case Pagination.First:
        hasPrev = false
        break;
      case Pagination.Last:
        hasNext = false
        break;
      default:
        break;
    }
    return {docs,firstDoc,lastDoc,hasNext, hasPrev };
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const updateArtifact = async (artifactId: string, data: any): Promise<void> =>  {
  return await updateDoc(doc(db, COLLECTIONS.FEEDS, artifactId), data);
};

const updateArtifactEdit = async (artifactId: string, data: any): Promise<void> =>  {
  return await updateDoc(doc(db, COLLECTIONS.CONTENT_CHANGE_REQUESTS, artifactId), data);
};

function removeNullFields(data:any) {
  return Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== null));
}

const updateArtifactStatus = async (artifactId: string, status: ContentState, subStatus: ContentSubstate, reason?:string, note?:string,): Promise<void> =>  {
  try {
    console.log(status)
    console.log(artifactId)
    if(status === ContentState.ACTIVE && subStatus === ContentSubstate.NONE){
      await updateArtifact(artifactId, {status, subStatus, lastActivityDate: Timestamp.now(), approvalDate: Timestamp.now()});
    }else{
      await updateArtifact(artifactId, {status, subStatus, lastActivityDate: Timestamp.now()});
    }
    
    await updateStatusHistory(artifactId, getContentHistoryStatusString(status, subStatus), reason, note)
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const updateArtifactEditStatus = async (artifactId: string, status: ContentState, subStatus: ContentSubstate, reason?:string, note?:string,): Promise<void> =>  {
  try {
    await updateArtifact(artifactId, {status, subStatus, lastActivityDate: Timestamp.now()});
    await updateStatusHistory(artifactId, getContentHistoryStatusString(status, subStatus, true), reason, note)
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const deleteArtifact = async (artifactId: string) => {
  await deleteDoc(doc(db, COLLECTIONS.FEEDS, artifactId));
};

const deleteArtifactEdit = async (artifactId: string) => {
  await deleteDoc(doc(db, COLLECTIONS.CONTENT_CHANGE_REQUESTS, artifactId));
};

const duplicateArtifact = async (artifactId:string) => {
  const sourceDocRef = doc(db, COLLECTIONS.FEEDS, artifactId);
  const sourceDocSnapshot = await getDoc(sourceDocRef);
  let data = sourceDocSnapshot.data() as SKArtifact
  const newData = {...data, status:ContentState.DRAFT, subStatus:ContentSubstate.NONE, createdDate: Timestamp.now(), updatedDate: Timestamp.now()}
  let newDocRef = await addDoc(collection(db, COLLECTIONS.FEEDS), newData);
  await updateStatusHistory(artifactId, "created")
  newData.id = newDocRef.id
  return newData
}
// Firebase Authentication services

const fetchArtifactReports = async (
  contentId: string,
  pageSize: number,
  moveTo?: Pagination,
  currentDoc?: QueryDocumentSnapshot,
): Promise<ArtifactReports> => {
  try {

    // const reportRef = contentReportDoc.collection(COLLECTIONS.REPORTS).doc(contentID);
    const reportsRef = collection(db, `${COLLECTIONS.REPORTS}/content/reports/${contentId}/reportedUsers`);

    // Step 1: Fetch top reported content IDs (sorted by `reportCount`)

    // const channelReportDoc = db.collection(COLLECTIONS.REPORTS).doc("channel");
    // const reportRef = channelReportDoc.collection(COLLECTIONS.REPORTS).doc(channelID);
    // const contentRef = db.collection("storeChannels").doc(channelID);
    // const userActionRef = reportRef.collection("reportedUsers").doc(userID);

    let reportsQuery = query(reportsRef, orderBy("reportedDate", "desc"), limit(pageSize + 1));
    
    const reportsSnapshot = await getDocs(reportsQuery);

    const docs = reportsSnapshot.docs.map(doc =>  doc.data()) as SKContentReport[];

    let firstDoc = docs.length > 0 ? reportsSnapshot.docs[0] : undefined;
    let lastDoc = docs.length > pageSize ? reportsSnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? reportsSnapshot.docs[pageSize - 1] : undefined);
    
    let hasNext = moveTo === Pagination.Next ? reportsSnapshot.size > pageSize : moveTo === Pagination.First && reportsSnapshot.size <= pageSize ? false : true;
    let hasPrev = !!currentDoc;

    switch (moveTo) {
      case Pagination.First:
        hasPrev = false;
        break;
      case Pagination.Last:
        hasNext = false;
        break;
      default:
        break;
    }

    return { docs, firstDoc, lastDoc, hasNext, hasPrev };
  } catch (error) {
    console.error("Error fetching reported content:", error);
    throw new Error("An error occurred while fetching data");
  }
};

export {
  getArtifact,
  getArtifactEdit,
  fetchMyArtifacts,
  fetchArtifacts,
  fetchReportedContent,
  fetchArtifactReports,
  createArtifact,
  createArtifactEdit,
  updateArtifact,
  updateArtifactEdit,
  updateArtifactStatus,
  updateArtifactEditStatus,
  updateStatusHistory,
  deleteArtifact,
  deleteArtifactEdit,
  duplicateArtifact,
  getStatusHistory,
  getCountsCreatorContent,
  getCountsModeratorContent
};